import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { TRANSLATIONS } from '../../../../translations';

import Card, {
  CardContentPosition,
  CardSizes,
} from '../../../ui-components/Card/Card';
import Image, {
  ImageShapes,
  ImageSizes,
} from '../../../ui-components/Image/Image';
import Typography, {
  TypographyWeights,
} from '../../../ui-components/Typography/Typography';

function SmartSearchActivityCard({ item, index }) {
  return (
    <Card
      className="activity-card"
      key={index}
      size={CardSizes.full}
      image={
        <Image
          source={item.cover_image}
          size={ImageSizes.large}
          shape={ImageShapes.squared}
          overlaid
          alt="Activity cover image"
        />
      }
      link={`${window.location.origin}${TRANSLATIONS.PRODUCT_DIRECTORY}/${item.slug}/`}
      content={
        <>
          <section className="activity-card--title d-flex flex-column justify-between">
            <Typography
              className="truncate-two-lines"
              variant="p3"
              weight={TypographyWeights['bold']}
            >
              {item.title}
            </Typography>
          </section>
          <section className="activity-card--info d-flex justify-between gap-base">
            <div className="activity-card--info--location d-flex flex-shrink-1">
              <Image
                classNames="pr-base"
                source="https://freedome.s3.eu-central-1.amazonaws.com/icons/pin-icon.svg"
                alt="Pin geografico"
                size="x-small"
                shape="rounded"
              />
              <Typography classNames="truncate" variant="p3">
                {item.city}
              </Typography>
            </div>
            <div className="activity-card--info--price flex-shrink-0">
              <Typography variant="p3" state="success">
                {TRANSLATIONS.FROM + ' '} <b> € {item.price_min_aggr}</b>
              </Typography>
            </div>
          </section>
        </>
      }
      contentPosition={CardContentPosition.right}
    />
  );
}

SmartSearchActivityCard.propTypes = {
  index: PropTypes.number,
  item: PropTypes.object,
};

export default memo(SmartSearchActivityCard);
